module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/6_f53c2c2ede8c78946680cc62eb3eb499.png";